import { useNavigation } from "react-router";
import { Inventory } from "~/components/metrika/Inventory";
import { Nav } from "~/components/metrika/Nav";
import { PaperDoll } from "~/components/metrika/PaperDoll";
import { PlayerStats } from "~/components/metrika/PlayerStats";
import { SkillList } from "~/components/metrika/SkillList";
import { Loader } from "~/components/site/Loader";
import { Breadcrumb } from "~/components/ui/Breadcrumb";
import { PageTitle } from "~/components/ui/PageTitle";
import { useT, useTurl } from "~/util/Lang";

type Character = {
  id: number;
  charName: string;
  baseClass?: number;
  curCp?: number | null;
  curHp?: number | null;
  curMp?: number | null;
  maxCp?: number | null;
  maxHp?: number | null;
  maxMp?: number | null;
  con?: number | null;
  crit?: number | null;
  dex?: number | null;
  evasion?: number | null;
  exp?: number | null;
  int?: number | null;
  karma?: number | null;
  level?: number | null;
  mAtk?: number | null;
  mDef?: number | null;
  mSpd?: number | null;
  maxload?: number | null;
  men?: number | null;
  pAtk?: number | null;
  pDef?: number | null;
  pSpd?: number | null;
  pkkills?: number | null;
  pvpkills?: number | null;
  runSpd?: number | null;
  sp?: number | null;
  str?: number | null;
  walkSpd?: number | null;
  wit?: number | null;
};

type Data = {
  character: Character;
};

export function CharacterPage(params: { data: Data }) {
  const { data } = params;
  const t = useT();
  const turl = useTurl();
  const title = t({ en: "Tracker", ru: "Tracker" });
  const navigation = useNavigation();

  return (
    <div className="content">
      <Breadcrumb
        items={[
          { title, url: turl("/tracker") },
          {
            title: data.character.charName,
            url: turl(`/tracker/${data.character.id}/character`),
          },
        ]}
      />
      <PageTitle>{data.character.charName}</PageTitle>
      <Nav character={data.character} />
      <div style={{ position: "relative" }}>
        <div className="columns">
          <div
            className="column"
            style={{ display: "flex", gap: 20, flexDirection: "column" }}
          >
            <PaperDoll gver={"c3"} data={{}} />
            <PlayerStats character={data.character} />
            <SkillList />
          </div>
          <div
            className="column"
            style={{ display: "flex", gap: 20, flexDirection: "column" }}
          >
            <Inventory
              data={[
                {
                  count: 10,
                  item: {
                    icon: "etc_adena_i00",
                    id: 57,
                    itemName: "adena",
                    name: "Adena",
                    type: "asset",
                  },
                },
              ]}
              title="Inventory"
            />
          </div>
          <div
            className="column"
            style={{ display: "flex", gap: 20, flexDirection: "column" }}
          ></div>
        </div>
        {navigation.state === "loading" ? <Loader /> : null}
      </div>
    </div>
  );
}
